import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_ACHIEVEMENTS_QUERY_KEY } from "./useListAchievements";

export const useDeleteAchievement = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (achievementId: string) => {
            if (!selectedOrganization?.id) throw new Error('No organization selected');
            return client.fetchApi<{ success: boolean }, {}>({
                endpoint: `achievements/admin/${selectedOrganization.id}/${achievementId}`,
                method: 'DELETE',
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_ACHIEVEMENTS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
